import type { ServiceContainer, ServiceProvider } from "../service-container";
import { BaseColorInterpolatorFactory } from "./BaseColorInterpolatorFactory";

/**
 * Color interpolation service provider.
 * @internal
 */
export const colorInterpolationProvider: ServiceProvider = {
  /**
   * Registers entities, related to color interpolation in service container.
   *
   * @param container
   */
  register(container: ServiceContainer) {
    container.register(
      "ColorInterpolatorFactory",
      new BaseColorInterpolatorFactory()
    );
  },
};
